import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDrop } from 'react-dnd'
import { Card, CardContent, Typography, Box, Button } from '@mui/material'
import OrderCard from './OrderCard'
import { useTranslation } from 'react-i18next'
import { STATUSES, MODES } from '../../lib/constants'
import { OrderModal } from '../../components'
import './Planning.scss'
// Drag and Drop item types
const ItemTypes = {
  ORDER: 'order',
}
const OrdersList = ({ deliveryOrders, moveOrderToList, isDragDisabled }) => {
  const { t } = useTranslation('planning_page')
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalMode, setModalMode] = useState(MODES.CREATE)
  const [, drop] = useDrop({
    accept: ItemTypes.ORDER,
    drop: (item) => moveOrderToList(item),
  })
  /// fonctions pour open modal create , edit , duplicate deliveryOrders
  const handleAddOrder = () => {
    setSelectedOrder({
      date: '',
      customerName: '',
      orderNumber: '',
      address: '',
      licensePlate: '',
      materials: [],
      status: STATUSES.INCOMPLETE,
    })
    setModalMode(MODES.CREATE)
    setIsModalOpen(true)
  }
  const handleModalClose = () => {
    setIsModalOpen(false)
    setSelectedOrder(null)
  }

  const handleSaveOrder = (order) => {
    console.log(order)
    //handleModalClose()
  }

  return (
    <>
      <Card ref={drop} style={{ margin: '8px', padding: '16px' , overflow:"auto" }}>
        <CardContent>
          <Box display="flex" alignItems="center">
            <Typography className="bold" variant="h5" marginRight={5}>
              {t('deliveryOrders')}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddOrder}
              disabled={isDragDisabled}
            >
              <span style={{ fontSize: '1.2rem', marginRight: '5px' }}>+</span>
              {t('newOrder')}
            </Button>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            gap="15px" // Espace fixe de 10px entre chaque OrderCard
            style={{
              maxWidth: '100%', // Limite la largeur au conteneur parent
              paddingLeft: '10px', // Espace initial à gauche
            }}
          >
            {deliveryOrders.map(({ node: deliveryOrder }, index) => (
              <OrderCard
                key={deliveryOrder.id}
                deliveryOrder={deliveryOrder}
                isDragDisabled={isDragDisabled}
                style={{
                  marginRight: index !== deliveryOrders.length - 1 ? '10px' : '0', // Espace de 10px entre les OrderCards, sauf pour la dernière
                }}
              />
            ))}
          </Box>
        </CardContent>
      </Card>

      {/*Si click sur le bouton acces a la modal d"edition ou de duplication */}
      {selectedOrder && (
        <OrderModal
          open={isModalOpen}
          onClose={handleModalClose}
          order={selectedOrder}
          onSave={handleSaveOrder}
          mode={modalMode}
        />
      )}
    </>
  )
}

OrdersList.propTypes = {
  deliveryOrders: PropTypes.array.isRequired,
  moveOrderToList: PropTypes.func.isRequired,
  isDragDisabled: PropTypes.bool,
}

export default OrdersList
